import { a as C, j as d } from "./jsx-runtime.mjs";
import { useState as E, useRef as $, useMemo as L, useEffect as P } from "react";
import { p as i } from "./config.mjs";
import { debounce as N } from "@vavt/util";
const M = (e, l) => {
  const o = (s) => {
    const n = e.parentElement || document.body, u = n.offsetWidth, v = n.offsetHeight, h = document.documentElement.clientWidth, f = document.documentElement.clientHeight, y = s.offsetX, g = s.offsetY, r = (c) => {
      let a = c.x + document.body.scrollLeft - document.body.clientLeft - y, t = c.y + document.body.scrollTop - document.body.clientTop - g;
      a = a < 1 ? 1 : a < h - u - 1 ? a : h - u - 1, t = t < 1 ? 1 : t < f - v - 1 ? t : f - v - 1, l ? l(a, t) : (n.style.left = a + "px", n.style.top = t + "px");
    };
    document.addEventListener("mousemove", r);
    const x = () => {
      document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", x);
    };
    document.addEventListener("mouseup", x);
  };
  return e.addEventListener("mousedown", o), () => {
    e.removeEventListener("mousedown", o);
  };
}, R = (e, l = "") => {
  const o = document.getElementById(e.id), s = e.onload;
  e.onload = null;
  const n = function(u) {
    typeof s == "function" && s.bind(this)(u), e.removeEventListener("load", n);
  };
  o ? l !== "" && (o.addEventListener("load", n), Reflect.get(window, l) && o.dispatchEvent(new Event("load"))) : (e.addEventListener("load", n), document.head.appendChild(e));
}, z = N((e, l, o) => {
  const s = document.getElementById(e);
  s && s.setAttribute(l, o);
}, 10), A = (e) => {
  const { onClose: l = () => {
  }, onAdjust: o = () => {
  }, style: s = {} } = e, [n, u] = E(e.visible), [v, h] = E([`${i}-modal`]), f = $(null), y = $(null), [g, r] = E({
    initPos: {
      left: "0px",
      top: "0px"
    },
    historyPos: {
      left: "0px",
      top: "0px"
    }
  }), x = L(() => e.isFullscreen ? {
    width: "100%",
    height: "100%"
  } : {
    width: e.width,
    height: e.height
  }, [e.height, e.isFullscreen, e.width]), [c, a] = E(!1);
  return P(() => {
    let t = () => {
    };
    return e.isFullscreen || (t = M(
      y.current,
      (m, b) => {
        r((H) => ({
          ...H,
          initPos: {
            left: m + "px",
            top: b + "px"
          }
        }));
      }
    )), t;
  }, [c, e.isFullscreen]), P(() => {
    if (n) {
      const t = f.current.offsetWidth / 2, m = f.current.offsetHeight / 2, b = document.documentElement.clientWidth / 2, H = document.documentElement.clientHeight / 2;
      r((w) => ({
        ...w,
        initPos: {
          left: b - t + "px",
          top: H - m + "px"
        }
      })), !c && a(!0);
    }
  }, [c, n]), P(() => {
    const t = e.visible;
    t ? (h(() => [`${i}-modal`, "zoom-in"]), u(t)) : c && (h(() => [`${i}-modal`, "zoom-out"]), setTimeout(() => {
      u(t);
    }, 150));
  }, [c, e.visible]), /* @__PURE__ */ C(
    "div",
    {
      className: e.className,
      style: { display: n ? "block" : "none", ...s },
      children: [
        /* @__PURE__ */ d("div", { className: `${i}-modal-mask`, onClick: l }),
        /* @__PURE__ */ C(
          "div",
          {
            className: v.join(" "),
            style: {
              ...g.initPos,
              ...x
            },
            ref: f,
            children: [
              /* @__PURE__ */ d("div", { className: `${i}-modal-header`, ref: y, children: e.title || "" }),
              /* @__PURE__ */ C("div", { className: `${i}-modal-func`, children: [
                e.showAdjust && /* @__PURE__ */ d(
                  "div",
                  {
                    className: `${i}-modal-adjust`,
                    onClick: (t) => {
                      t.stopPropagation(), e.isFullscreen ? r((m) => ({
                        ...m,
                        initPos: m.historyPos
                      })) : r((m) => ({
                        historyPos: m.initPos,
                        initPos: {
                          left: "0",
                          top: "0"
                        }
                      })), o instanceof Function && o(!e.isFullscreen);
                    },
                    children: /* @__PURE__ */ d("svg", { className: `${i}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ d(
                      "use",
                      {
                        xlinkHref: `#md-editor-icon-${e.isFullscreen ? "suoxiao" : "fangda"}`
                      }
                    ) })
                  }
                ),
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: `${i}-modal-close`,
                    onClick: (t) => {
                      t.stopPropagation(), e.onClose && e.onClose();
                    },
                    children: /* @__PURE__ */ d("svg", { className: `${i}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ d("use", { xlinkHref: "#md-editor-icon-close" }) })
                  }
                )
              ] }),
              /* @__PURE__ */ d("div", { className: `${i}-modal-body`, children: e.children })
            ]
          }
        )
      ]
    }
  );
};
export {
  A as M,
  R as a,
  z as u
};
